import { render, staticRenderFns } from "./WhatsNewList.vue?vue&type=template&id=90fed588"
import script from "./WhatsNewList.vue?vue&type=script&lang=js"
export * from "./WhatsNewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports